module.exports = __webpack_public_path__ + "media/images/emblems/Muemliswil-Ramiswil-blason-4f972ed455447dd2f3cb4b90a4a44abe.png";